/** @jsxImportSource @emotion/react */

import { Box, css } from '@mui/material';
import RadioSelectList from './RadioSelectList';

const FilterNDownload = (props: { pdf: string; setSelectedColor: Function; filterList: string[]; design: string }) => {
  const { design, setSelectedColor, filterList, pdf } = props;

  const handleDownload = () => {
    // 샘플북 다운
    if (!!pdf && pdf !== '') {
      window.open(pdf, '_blank');
    }
  };

  return (
    <Box css={style.root}>
      <Box css={style.radio}>
        <RadioSelectList design={design} selected={setSelectedColor} list={filterList} />
      </Box>
      <Box css={style.btn} onClick={handleDownload}>
        샘플북 다운로드
      </Box>
    </Box>
  );
};

const style = {
  root: css`
    border-top: 1px solid #00000070;
    padding: 8px 0;
    display: flex;
    position: relative;
    width: 100%;
    margin: 8px 0;
    align-items: center;
    @media (max-width: 768px) {
      align-items: flex-start;
      height: 72px;
    }
  `,
  radio: css`
    width: 80%;
    overflow-x: auto;
    @media (max-width: 768px) {
      width: 100%;
    }
  `,
  btn: css`
    position: absolute;
    right: 4px;
    border: 1px solid black;
    border-radius: 4px;
    padding: 4px 8px;
    width: 120px;
    display: flex;
    justify-content: center;
    cursor: pointer;
    &:hover {
      box-shadow: 0px 0px 3px black;
    }
    &:active {
      background-color: #87cfeb40;
    }
    @media (max-width: 768px) {
      bottom: 0px;
    }
  `,
};

export default FilterNDownload;
